import { rootApi } from '../rootApi';

export const vehicleAcceptanceFormApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getListVehicleAcceptanceForm: builder.query({
            query: (params) => {
                const body = {
                    ...params,
                    PageNumber: params.PageNumber !== undefined ? params.PageNumber : 0,
                    PageSize: params.PageSize || 10
                };

                return {
                    url: 'v1/VehicleAcceptanceForm/GetList',
                    method: 'POST',
                    body: body
                };
            },
            transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data.vehicleAcceptanceFormGetListQueryItems)) {
                        return response.data;
                    }
                    if (Array.isArray(response)) {
                        return response;
                    }
                    return { vehicleAcceptanceFormGetListQueryItems: [], totalCount: 0, statusCounts: [] };
                }
                return [];
            },
            providesTags: ['VehicleAcceptanceForm']
        }),

        getVehicleAcceptanceFormById: builder.query({
            query: (id) => `v1/VehicleAcceptanceForm/GetById?id=${id}`,
            providesTags: (result, error, id) => [{ type: 'VehicleAcceptanceForm', id }]
        }),

        addVehicleAcceptanceForm: builder.mutation({
            query: (data) => ({
                url: 'v1/VehicleAcceptanceForm/Add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['VehicleAcceptanceForm']
        }),

        updateVehicleAcceptanceForm: builder.mutation({
            query: (data) => ({
                url: 'v1/VehicleAcceptanceForm/Update',
                method: 'POST',
                body: data.data
            }),
            invalidatesTags: (result, error, { data }) => [{ type: 'VehicleAcceptanceForm', id: data.id }]
        }),

        deleteVehicleAcceptanceForm: builder.mutation({
            query: (id) => ({
                url: 'v1/VehicleAcceptanceForm/Delete',
                method: 'DELETE',
                body: { Id: id.id }
            }),
            invalidatesTags: ['VehicleAcceptanceForm']
        }),

        checkActiveByChasisNo: builder.query({
            query: (chasisNo) => `v1/VehicleAcceptanceForm/CheckActiveByChasisNo?chasisNo=${chasisNo}`
        }),

        approvementVehicleAcceptanceForm: builder.mutation({
            query: (data) => ({
                url: 'v1/VehicleAcceptanceForm/Approvement',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['VehicleAcceptanceForm']
        }),

        uploadDocument: builder.mutation({
            query: (data) => {
                const formData = new FormData();
                formData.append('VehicleAcceptanceFormId', data.vehicleAcceptanceFormId);
                formData.append('File', data.file);
                formData.append('Description', data.description);
                return {
                    url: 'v1/VehicleAcceptanceForm/UploadDocument',
                    method: 'POST',
                    body: formData
                };
            },
            invalidatesTags: (result, error, { vehicleAcceptanceFormId }) => [{ type: 'VehicleAcceptanceFormDocuments', id: vehicleAcceptanceFormId }]
        }),

        getDocumentsById: builder.query({
            query: (id) => ({
                url: `v1/VehicleAcceptanceForm/GetDocumentsById?Id=${id}`,
                method: 'GET'
            }),
            transformResponse: (response) => response?.data ?? [],
            providesTags: (result, error, id) => [{ type: 'VehicleAcceptanceFormDocuments', id }]
        }),

        deleteDocument: builder.mutation({
            query: (data) => ({
                url: 'v1/VehicleAcceptanceForm/DeleteDocument',
                method: 'DELETE',
                body: data
            }),
            invalidatesTags: (result, error, { vehicleAcceptanceFormId }) => [{ type: 'VehicleAcceptanceFormDocuments', id: vehicleAcceptanceFormId }]
        }),

        getVehicleAcceptanceFormHistory: builder.query({
            query: ({ id, pageSize = 10, pageNumber = 0, languageId = 1 }) => ({
                url: `v1/vehicleacceptanceform/gethistorybyid?Id=${id}&PageSize=${pageSize}&PageNumber=${pageNumber}&LanguageId=${languageId}`,
                method: 'GET'
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount
                    };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: (result, error, { id }) => [{ type: 'VehicleAcceptanceForm', id: `history-${id}` }]
        }),
         exportVehicleAcceptanceToExcel: builder.query({
            query: (params) => ({
                url: 'v1/vehicleacceptanceform/exporttoexcel',
                method: 'POST',
                body: {
                    status: params.Status ?? null,
                    startDate: params.startDate ?? null,
                    endDate: params.endDate ?? null,
                    vehicleAcceptanceStartDate: params.vehicleAcceptanceStartDate ?? null,
                    vehicleAcceptanceEndDate: params.vehicleAcceptanceEndDate ?? null,
                    dealerList: params.dealerIds ?? [],
                    chassisList: params.chassisNos ?? [],
                    countries: params.countries ?? [],
                    languageId: params.languageId ?? 1,
                    compressionType: params.compressionType ?? 0
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || 'Export failed');
            }
        })
    })
});

export const {
    useGetListVehicleAcceptanceFormQuery,
    useGetVehicleAcceptanceFormByIdQuery,
    useAddVehicleAcceptanceFormMutation,
    useUpdateVehicleAcceptanceFormMutation,
    useDeleteVehicleAcceptanceFormMutation,
    useCheckActiveByChasisNoQuery,
    useApprovementVehicleAcceptanceFormMutation,
    useUploadDocumentMutation,
    useGetDocumentsByIdQuery,
    useLazyGetDocumentsByIdQuery,
    useDeleteDocumentMutation,
    useGetVehicleAcceptanceFormHistoryQuery,
    useLazyExportVehicleAcceptanceToExcelQuery
} = vehicleAcceptanceFormApi;
